export default __webpack_public_path__ + "static/1218-c609367d8f9a9055a0cb57e7c5478dfa.gif";